module.exports = __webpack_public_path__ + "img/header-icono-scrolldown.53d17fde.svg";